import { Component, input, output, signal } from '@angular/core';
import {
  TaskCancelReasonResponse,
  TaskResponse,
} from '../../models/task.model';

@Component({
  selector: 'app-task-cancel-dialog',
  imports: [],
  templateUrl: './task-cancel-dialog.component.html',
})
export class TaskCancelDialogComponent {
  visible = input<boolean>(false);
  reason = input<TaskCancelReasonResponse[]>();
  task = input<TaskResponse>();
  cancel = output<{ taskId: number; reasonId: number; notes: string }>();
  closed = output<void>();
  selectedReasonId = signal<number | null>(null);
  notes = signal('');

  close(): void {
    this.notes.set('');
    this.selectedReasonId.set(null);
    this.closed.emit();
  }

  confirm(): void {
    const task = this.task();
    const reasonId = this.selectedReasonId();

    if (!task?.id || !reasonId) return;

    this.cancel.emit({
      taskId: task.id,
      reasonId,
      notes: this.notes(),
    });

    this.notes.set('');
  }

  changeReason(event: Event): void {
    const value = Number((event.target as HTMLSelectElement).value);
    this.selectedReasonId.set(value);
  }

  onNotesChange(event: Event): void {
    const value = (event.target as HTMLTextAreaElement).value;
    this.notes.set(value);
  }
}
